import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/catch';

// Servicio para verificar token
import { EmpleadosServicio } from './empleado.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private route: Router, private empleadoService: EmpleadosServicio) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // Verificar que el localStorage existe
    if (localStorage.getItem('token')) {
      return this.empleadoService.verificarTokenSesion().map((res: any) => {
        if (res) {
          this.empleadoService.datosEmpleado = res;
          this.empleadoService.paginasAsignadas = res.paginasAsignadas;
          this.empleadoService.permisosAsignados = res.permisosAsignados;
          return true;
        }
      }).catch((err) => {
          if (err) {
            if (err.status === 401) {

              localStorage.removeItem('token');
              localStorage.setItem('session', 'expired');
              this.route.navigate(['/login']);
              return of(false);
            } else {
              // Enviar a la pagina 500
            }
          }
      });

    } else {
      this.route.navigate(['/login']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/auth-guard.service.ts